module.exports = __webpack_public_path__ + "static/media/headerLogo.d8dd7d3a.png";